import * as React from "react";
import { ReactSVG } from "react-svg";
// Mismo SVG por defecto que en el listado de productos cuando la imagen no existe
import imagenPorDefectoSvg from "../assets/ic_cc.svg";

const MAX_W_VW = 90;
const MAX_H_VH = 90;

function getContainSize(naturalWidth, naturalHeight) {
  const maxW = (window.innerWidth * MAX_W_VW) / 100;
  const maxH = (window.innerHeight * MAX_H_VH) / 100;
  const r = naturalWidth / naturalHeight;
  let w, h;
  if (r > maxW / maxH) {
    w = maxW;
    h = maxW / r;
  } else {
    w = maxH * r;
    h = maxH;
  }
  return { width: w, height: h };
}

export default class ModalImagen extends React.Component {
  state = { size: null, imageError: false };
  imgRef = React.createRef();

  componentDidMount() {
    window.addEventListener("resize", this.updateSize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateSize);
  }

  componentDidUpdate(prevProps) {
    if (this.props.imagenSrc !== prevProps.imagenSrc) {
      this.setState({ size: null, imageError: false });
    }
  }

  updateSize = () => {
    const img = this.imgRef.current;
    if (img && img.naturalWidth && img.naturalHeight) {
      this.setState({ size: getContainSize(img.naturalWidth, img.naturalHeight) });
    }
  };

  onImageLoad = () => {
    const img = this.imgRef.current;
    if (img && img.naturalWidth && img.naturalHeight) {
      this.setState({ size: getContainSize(img.naturalWidth, img.naturalHeight) });
    }
  };

  onImageError = () => {
    this.setState({ imageError: true });
  };

  render() {
    const { mostrar, imagenSrc, imagenAlt, onCerrar } = this.props;
    const { size, imageError } = this.state;

    if (!mostrar) {
      return null;
    }

    // Sin URL de imagen o la imagen falló al cargar: mostrar SVG por defecto
    const usarImagenPorDefecto = !imagenSrc || imageError;

    // Algunos bundlers devuelven la URL en .default
    const urlSvgPorDefecto =
      typeof imagenPorDefectoSvg === "string"
        ? imagenPorDefectoSvg
        : imagenPorDefectoSvg?.default ?? imagenPorDefectoSvg;

    const imgStyle = size && !usarImagenPorDefecto
      ? { width: size.width, height: size.height, objectFit: "contain" }
      : { maxWidth: "90vw", maxHeight: "90vh", objectFit: "contain" };

    const defaultSvgStyle = {
      width: "200px",
      height: "200px",
      maxWidth: "90vw",
      maxHeight: "90vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          zIndex: 9999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={onCerrar}
      >
        <div
          style={{
            position: "relative",
            display: "inline-block",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {usarImagenPorDefecto ? (
            <div style={defaultSvgStyle} aria-label={imagenAlt || "Imagen no disponible"}>
              <ReactSVG src={urlSvgPorDefecto} style={{ width: "100%", height: "100%" }} />
            </div>
          ) : (
            <img
              ref={this.imgRef}
              src={imagenSrc}
              alt={imagenAlt || "Imagen"}
              style={imgStyle}
              onLoad={this.onImageLoad}
              onError={this.onImageError}
            />
          )}
          <button
            onClick={onCerrar}
            style={{
              position: "absolute",
              top: "-35px",
              right: "0px",
              backgroundColor: "rgb(234, 63, 63)",
              border: "none",
              //borderRadius: "50%",
              width: "35px",
              height: "35px",
              fontSize: "30px",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              color: "white",
              lineHeight: "1",
            }}
          >
            ×
          </button>
        </div>
      </div>
    );
  }
}

